module.exports = __webpack_public_path__ + "2e44d53ae6a7695631016d4ec5c7939b.svg";